import { css } from "@emotion/react";

import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";
import { useOverflow } from "shared";

import { NameWithTooltipProps } from "./types";

export const NameWithTooltip = ({
    name,
    lineH,
    fontSize
}: NameWithTooltipProps) => {
    const { ref, isOverflowing } = useOverflow();

    return (
        <TooltipGeneral
            title={name}
            placement={TOOLTIP_PLACEMENT.Top}
            disableHoverListener={!isOverflowing}
        >
            <span
                ref={ref}
                css={css({
                    fontSize: `${fontSize}px`,
                    lineHeight: `${lineH}px`,
                    whiteSpace: "nowrap",
                    overflowX: "hidden",
                    textOverflow: "ellipsis",
                    display: "block !important"
                })}
            >
                {name}
            </span>
        </TooltipGeneral>
    );
};

export default NameWithTooltip;
